import Navbar from "@/components/Navbar";
import MainSection from "@/components/MainSection";
import EngineeringSection from "@/components/EngineeringSection";
import ProjectsSection from "@/components/ProjectsSection";
import CompanySection from "@/components/CompanySection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import SolutionsSection from "@/components/SolutionsSection";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <MainSection />
      <div className="line-red" />
      <SolutionsSection />
      <div className="line-red" />
      <EngineeringSection />
      <ProjectsSection />
      <div className="line-red" />
      <CompanySection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
